import { useRef } from "react";
import { toast } from "sonner";

const MIN_CHARS = 20;
const norm = (s) => (s || "").replace(/\s+/g, " ").trim();

// Counts text pasted into the editor from outside it (copy/cut inside the editor is ignored).
export function usePasteGuard(setProctor, selectionRef) {
  const internal = useRef("");
  const warned = useRef(false);
  const onCopy = (e) => {
    const t = e.target;
    internal.current = norm(selectionRef?.current ? selectionRef.current() : t.value?.slice(t.selectionStart, t.selectionEnd));
  };
  const onPaste = (e) => {
    const text = e.clipboardData?.getData("text") || "";
    if (!text || (internal.current && norm(text) === internal.current)) return;
    setProctor((p) => ({
      ...p,
      paste_events: (p.paste_events || 0) + 1,
      pasted_chars: (p.pasted_chars || 0) + text.length,
      largest_paste: Math.max(p.largest_paste || 0, text.length),
    }));
    if (text.length >= MIN_CHARS && !warned.current) {
      warned.current = true;
      toast.warning("Pasted text is recorded and shown to the hiring team.");
    }
  };
  return { onCopy, onCut: onCopy, onPaste };
}
